// ** React Imports
import React, { useEffect, useState, useMemo } from 'react'
import { Outlet } from 'react-router-dom'

// ** Custom Hooks
import { useSkin } from '@hooks/useSkin'

// ** Third Party Components
import classnames from 'classnames'

const BlankLayout = () => {
  // ** States
  const [isMounted, setIsMounted] = useState(false)

  // ** Hooks
  const { skin } = useSkin()

  // ** Mount check to prevent unnecessary rerenders
  useEffect(() => {
    setIsMounted(true)
    return () => setIsMounted(false)
  }, [])

  // ** Memoize Outlet content (prevents Outlet remounts)
  const content = useMemo(() => <Outlet />, [])

  if (!isMounted) return null

  return (
    <div
      className={classnames('blank-page', {
        'dark-layout': skin === 'dark'
      })}
    >
      <div className="app-content content">
        <div className="content-wrapper">
          <div className="content-body">{content}</div>
        </div>
      </div>
    </div>
  )
}

export default React.memo(BlankLayout)
